import { useUserInfo } from "../../../shared/hooks/use-user-info";

export const ProfilePageTitle = () => {
  const userInfo = useUserInfo();
  const fullName = userInfo?.fullName ?? "—";

  return (
    <h1 className="heading-h4">
      <span className="text-type-light">Профиль</span>
      <br />
      <span>{fullName}</span>
    </h1>
  );
};
